<div class="beleg-selection-page">
  <h2>{{ 'new_antrag.stepper.label.second_step.head.title' | translate }}</h2>
  <p
    [innerHTML]="
      'new_antrag.stepper.label.second_step.head.description'
        | translate
          : {
              maximumFileSizeInMb: maximumFileSizeInMb,
              maximumAntragSizeInMb: maximumAntragSizeInMb,
            }
        | bypassSecurityPipe: 'html'
    "
    class="beleg-selection-page__explanation-text"></p>

  @if (antrag | currentSizeInByte: antrag.getSeitenLength() | async; as antragSize) {
    <div class="beleg-selection-page__section">
      <ebeihilfe-simple-progress
        [block]="true"
        [progress]="antrag | percentageOfMaxSize: maximumAntragSizeInMb : antrag.getSeitenLength() | async">
        <span>{{ antragSize | bToMb | number: '1.1-1' }} von {{ maximumAntragSizeInMb }} MB</span>
      </ebeihilfe-simple-progress>
    </div>
  }

  @if (antrag | maxSizeExceeded: maximumAntragSizeInMb : antrag.getSeitenLength() | async) {
    <span class="text-danger font-weight-bold">
      {{ 'new_antrag.label.maximal_antragssize_exceeded' | translate }}
    </span>
  }

  <div class="beleg-selection-page__section">
    <mat-accordion>
      @for (beleg of antrag.belege; track beleg; let i = $index; let first = $first) {
        <portal-beleg
          (addNewSeiteToBeleg)="addPageToBeleg(beleg)"
          (deleteBelegModal)="openDeleteBelegModal(beleg)"
          (moveBelegToTopEmitter)="moveBelegToTop(beleg)"
          (openModal)="openImageDetailView($event)"
          (removeFileFromDocument)="removeSeiteFromAntrag(beleg, $event)"
          [belegIndex]="firstBelegIsMandatory ? (first ? 1 : i - 1) : i"
          [beleg]="beleg"
          [canRemoveBeleg]="antrag.belege.length > 1"
          [focusMoveUpBtn]="focusMoveUpBtn"
          [isMandatory]="first && firstBelegIsMandatory"
          [pagesNeeded]="mandatoryPages" />
      }
    </mat-accordion>
    <form [formGroup]="uploadFileform" hidden="hidden">
      <input
        #fileInput
        (change)="fileInputOnChangeEvent($event)"
        accept=".jpeg, .jpg, .png, .pdf"
        multiple
        name="files[]"
        type="file" />
    </form>
  </div>
  <div class="beleg-selection-page__button-row">
    <button (click)="antrag.addBeleg()" [disabled]="!antrag.canAddBeleg()" color="accent" mat-flat-button type="button">
      {{ 'new_antrag.button.add_new_beleg' | translate }}
    </button>
    <div class="beleg-selection-page__button-row--grouped">
      @if (customerHasUnfinishedAntragsFeature) {
        <button
          (click)="interruptAntrag()"
          [disabled]="(antrag | canSendAntrag: maximumAntragSizeInMb : antrag.getSeitenLength() | async) === false"
          class="beleg-selection-page__button-row--grouped__interrupt-button"
          color="accent"
          mat-flat-button
          type="button">
          {{ 'new_antrag.button.pause_antrag' | translate }}
        </button>
      }
      <button
        (click)="finishBelegSelection()"
        [disabled]="
          (dailyLimitExceeded | async) ||
          (antrag | canSendAntrag: maximumAntragSizeInMb : antrag.getSeitenLength() | async) === false ||
          (antrag | hasAllMandatoryPages: antrag.getSeitenLength()) === false
        "
        class="beleg-selection-page__button-row--grouped__finish-button"
        color="primary"
        mat-flat-button
        type="button">
        {{ 'new_antrag.button.finish_antrag' | translate }}
      </button>
    </div>
  </div>
</div>
<ng-template #einreichungsSpinnerData>
  <mat-card appearance="outlined" tabindex="0">
    <mat-card-content>
      @if (!showPureTextOnly && pdfProgress.text) {
        <p class="loading-text">
          {{ pdfProgress.current + '/' + pdfProgress.allFiles }} -- {{ pdfProgress.text | translate }}
        </p>
      }
      @if (showPureTextOnly) {
        <p class="loading stuff">
          {{ text | translate }}
        </p>
      }
    </mat-card-content>
  </mat-card>
</ng-template>
